export default "<div class=\"bodyContent\">\n  <router-outlet></router-outlet>\n</div>"